export default __webpack_public_path__ + "static/media/item6.6dc63804.jpg";